var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/Policy"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.877 2.79h4.473c1.865 0 3.376 1.451 3.376 3.242v12.993c0 1.79-1.511 3.242-3.376 3.242h-2.572m0 0H5.65c-1.865 0-3.376-1.452-3.376-3.242v-.21l.048-12.48v-1.36c0-1.79 1.512-3.242 3.376-3.242h7.128m2.952 20.534c1.865 0 3.376-1.452 3.376-3.242V8.093M6.213 13.621h9.296m3.645-5.528H14.29c-.808 0-1.463-.629-1.463-1.405V1.733m6.328 6.36-6.328-6.36M6.213 10.92V9.3m0 0V5.515h1.969c1.088 0 1.97.846 1.97 1.89 0 1.045-.882 1.892-1.97 1.892h-1.97Zm0 8.104h5.92",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/Policy.d9a34107e2f93587e44eecce0099ba2b.svg";
export { ForwardRef as ReactComponent };